import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SmartphoneIcon } from 'lucide-react';
export function NfcTapAnimation() {
  const handleScrollToVideo = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const videoSection = document.getElementById('video-demo');
    if (videoSection) {
      const yOffset = -80; // Offset for fixed navbar
      const y = videoSection.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  return <section id="nfc-animation" className="pt-8 pb-0 md:py-28 bg-brand-darkest relative overflow-hidden" data-id="element-299">
      {/* Ambient background */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,102,255,0.06)_0%,transparent_70%)]" data-id="element-300" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-301">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-3 md:mb-20" data-id="element-302">
          <span className="text-brand-cyan font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-303">
            See It In Action
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold" data-id="element-304">
            Tap. Connect. <span className="text-gradient" data-id="element-305">Instantly.</span>
          </h2>
        </motion.div>

        {/* Animation Stage */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative mx-auto aspect-[4/5] sm:aspect-[16/11] md:aspect-[16/10]" style={{
        maxWidth: 700
      }} data-id="element-306">
          {/* Scene container */}
          <div className="relative w-full h-full overflow-hidden flex items-center justify-center" data-id="element-307">
            {/* ─── T-SHIRT IMAGE (USA) ─── */}
            <div className="absolute inset-0 flex items-start md:items-center justify-center pt-0 md:pt-0" data-id="element-308">
              <div className="relative w-[65%] xs:w-[70%] sm:w-[68%] md:w-[60%] lg:w-[55%] -mt-8 md:mt-0" style={{
              WebkitMaskImage: 'radial-gradient(ellipse 90% 90% at 50% 47%, black 40%, transparent 72%)',
              maskImage: 'radial-gradient(ellipse 90% 90% at 50% 47%, black 40%, transparent 72%)'
            }} data-id="element-309">
                <img src="https://cdn.magicpatterns.com/uploads/ajNdWyfLwQPSN6Cbe4HL66/ChatGPT_Image_Mar_24,_2026,_10_52_59_AM.png" alt="USA Qtap NFC Smart T-Shirt" loading="lazy" className="w-full h-auto object-contain select-none pointer-events-none" style={{
                filter: 'brightness(0.85) contrast(1.15) saturate(1.1)',
                mixBlendMode: 'lighten'
              }} draggable={false} data-id="element-310" />
              </div>
            </div>

            {/* ─── NFC SIGNAL on RIGHT sleeve (Qtap logo area) ─── */}
            <div className="absolute z-[1]" style={{
            top: '18%',
            right: '20%'
          }} data-id="element-311">
              {/* Qtap logo — concentric circles matching the sleeve logo */}
              <motion.div className="relative w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 flex items-center justify-center" data-id="element-312">
                {/* Glow behind logo */}
                <motion.div className="absolute inset-[-6px] rounded-full bg-brand-cyan/20" animate={{
                scale: [1, 1.6, 1],
                opacity: [0.15, 0.4, 0.15]
              }} transition={{
                duration: 2.5,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-313" />

                {/* SVG Qtap logo — concentric circles like the actual sleeve logo */}
                <svg viewBox="0 0 40 40" className="w-full h-full relative z-10" fill="none" data-id="element-314">
                  {/* Outer ring */}
                  <motion.circle cx="20" cy="20" r="16" stroke="rgba(77,159,255,0.6)" strokeWidth="2" fill="none" animate={{
                  opacity: [0.4, 0.8, 0.4]
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} data-id="element-315" />
                  {/* Middle ring */}
                  <motion.circle cx="20" cy="20" r="10" stroke="rgba(77,159,255,0.8)" strokeWidth="2" fill="none" animate={{
                  opacity: [0.5, 1, 0.5]
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut',
                  delay: 0.15
                }} data-id="element-316" />
                  {/* Inner dot */}
                  <motion.circle cx="20" cy="20" r="4" fill="rgba(77,159,255,1)" animate={{
                  r: [4, 5, 4],
                  fill: ['rgba(0,102,255,0.8)', 'rgba(77,159,255,1)', 'rgba(0,102,255,0.8)']
                }} transition={{
                  duration: 1.8,
                  repeat: Infinity
                }} data-id="element-317" />
                  {/* Target crosshair — small lines for the "C" shape in the logo */}
                  <motion.path d="M20 8 A12 12 0 1 1 8 20" stroke="rgba(77,159,255,0.5)" strokeWidth="1.5" strokeLinecap="round" fill="none" animate={{
                  opacity: [0.3, 0.7, 0.3]
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  delay: 0.3
                }} data-id="element-318" />
                </svg>
                {/* ─── SIGNAL WAVES radiating from logo center ─── */}
                {[{
                delay: 0,
                maxScale: 2.2,
                borderColor: 'border-brand-cyan/35'
              }, {
                delay: 0.9,
                maxScale: 4.2,
                borderColor: 'border-brand-sky/12'
              }].map((wave, i) => <motion.div key={i} className={`absolute rounded-full border ${wave.borderColor}`} style={{
                width: '100%',
                height: '100%',
                top: 0,
                left: 0
              }} animate={{
                scale: [1, wave.maxScale],
                opacity: [0.45, 0]
              }} transition={{
                duration: 2.4,
                repeat: Infinity,
                ease: 'easeOut',
                delay: wave.delay
              }} data-id="element-319" />)}
              </motion.div>
            </div>

            {/* ─── PHONE approaching from the RIGHT toward the sleeve logo ─── */}
            <motion.div className="absolute z-20" style={{
            top: '8%',
            right: '8%'
          }} animate={{
            x: [0, -40, -40, 0],
            y: [20, 15, 15, 20]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut',
            times: [0, 0.3, 0.7, 1]
          }} data-id="element-320">
              {/* Phone body */}
              <div className="relative rounded-2xl flex flex-col items-center justify-center" style={{
              width: 'clamp(50px, 5.5vw, 88px)',
              height: 'clamp(86px, 9.5vw, 152px)',
              background: 'linear-gradient(180deg, rgba(20,24,40,0.97) 0%, rgba(12,15,28,0.99) 100%)',
              border: '1.5px solid rgba(255,255,255,0.12)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 40px rgba(0,102,255,0.06), inset 0 1px 0 rgba(255,255,255,0.08)'
            }} data-id="element-321">
                {/* Notch */}
                <div className="absolute top-1.5 w-7 h-1 rounded-full bg-white/10" data-id="element-322" />

                {/* Screen — idle state */}
                <motion.div className="absolute inset-2 rounded-xl flex flex-col items-center justify-center gap-1 overflow-hidden" animate={{
                opacity: [1, 1, 0, 0, 0, 1]
              }} transition={{
                duration: 5,
                repeat: Infinity,
                times: [0, 0.25, 0.3, 0.65, 0.7, 0.85]
              }} data-id="element-323">
                  <SmartphoneIcon className="w-3.5 h-3.5 text-brand-glow/40" data-id="element-324" />
                  <div className="w-7 h-0.5 rounded-full bg-white/10 mt-0.5" data-id="element-325" />
                  <span className="text-[5px] sm:text-[6px] text-gray-500 font-medium" data-id="element-326">
                    Ready to scan
                  </span>
                </motion.div>

                {/* Screen — connected: US Team Profile */}
                <motion.div className="absolute inset-2 rounded-xl overflow-hidden flex flex-col items-center" style={{
                background: 'linear-gradient(180deg, rgba(0,40,104,0.95) 0%, rgba(10,20,60,0.98) 100%)'
              }} animate={{
                opacity: [0, 0, 1, 1, 1, 0]
              }} transition={{
                duration: 5,
                repeat: Infinity,
                times: [0, 0.28, 0.35, 0.6, 0.65, 0.8]
              }} data-id="element-327">
                  <motion.div className="flex flex-col items-center w-full h-full px-1 py-1.5 sm:py-2" animate={{
                  scale: [0.85, 1]
                }} transition={{
                  duration: 0.4,
                  delay: 1.6,
                  repeat: Infinity,
                  repeatDelay: 4.6
                }} data-id="element-328">
                    {/* Flag + Team Name */}
                    <span className="text-[8px] sm:text-[10px] leading-none" data-id="element-329">
                      🇺🇸
                    </span>
                    <span className="text-[6px] sm:text-[8px] md:text-[9px] font-black text-white tracking-wider mt-0.5 leading-none" data-id="element-330">
                      USA
                    </span>
                    <span className="text-[4px] sm:text-[5px] text-blue-300/70 font-medium mt-0.5 leading-none" data-id="element-331">
                      FIFA World Cup 2026
                    </span>

                    {/* Divider */}
                    <div className="w-3/4 h-px bg-white/10 my-1" data-id="element-332" />

                    {/* Stats row */}
                    <div className="flex items-center gap-1" data-id="element-333">
                      <span className="text-[4px] sm:text-[5px] text-gray-300 font-semibold" data-id="element-334">
                        Group B
                      </span>
                      <div className="w-0.5 h-0.5 rounded-full bg-white/30" data-id="element-335" />
                      <span className="text-[4px] sm:text-[5px] text-gray-300 font-semibold" data-id="element-336">
                        Rank #11
                      </span>
                    </div>

                    {/* Next match */}
                    <div className="mt-1 px-1.5 py-0.5 rounded-sm bg-red-600/30 border border-red-500/20" data-id="element-337">
                      <span className="text-[3.5px] sm:text-[4.5px] text-red-200 font-bold uppercase tracking-wide" data-id="element-338">
                        Next: vs England · Jun 15
                      </span>
                    </div>

                    {/* Roster preview */}
                    <div className="mt-1 flex flex-col items-center" data-id="element-339">
                      <span className="text-[3px] sm:text-[4px] text-gray-500 uppercase tracking-widest font-bold" data-id="element-340">
                        Roster
                      </span>
                      <span className="text-[3.5px] sm:text-[4.5px] text-gray-300 mt-0.5 text-center leading-tight" data-id="element-341">
                        Pulisic · McKennie · Reyna
                      </span>
                    </div>

                    {/* Social links */}
                    <div className="mt-auto mb-0.5 flex items-center gap-1.5" data-id="element-342">
                      <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full bg-gradient-to-br from-pink-500 to-yellow-400 opacity-70" data-id="element-343" />
                      <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full bg-white/20 flex items-center justify-center" data-id="element-344">
                        <span className="text-[4px] text-white font-black" data-id="element-345">
                          𝕏
                        </span>
                      </div>
                      <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full bg-white/10 flex items-center justify-center" data-id="element-346">
                        <span className="text-[4px] text-cyan-400" data-id="element-347">♪</span>
                      </div>
                    </div>
                  </motion.div>
                </motion.div>

                {/* Connection flash */}
                <motion.div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
                background: 'radial-gradient(circle at center, rgba(0,102,255,0.2) 0%, transparent 70%)'
              }} animate={{
                opacity: [0, 0, 1, 0.5, 0]
              }} transition={{
                duration: 5,
                repeat: Infinity,
                times: [0, 0.28, 0.33, 0.45, 0.6]
              }} data-id="element-348" />
              </div>

              {/* Phone glow */}
              <motion.div className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-12 h-3 bg-brand-cyan/10 rounded-full blur-xl" animate={{
              opacity: [0.2, 0.5, 0.2]
            }} transition={{
              duration: 2,
              repeat: Infinity
            }} data-id="element-349" />
            </motion.div>

            {/* ─── DATA TRANSFER PARTICLES (from logo to phone) ─── */}
            {[0, 1, 2].map(i => <motion.div key={i} className="absolute w-1 h-1 bg-brand-glow rounded-full z-10" style={{
            top: '30%',
            right: '21%',
            boxShadow: '0 0 6px rgba(77,159,255,0.8)'
          }} animate={{
            x: [0, 10 + i % 3 * 4, 28],
            y: [0, 4 + (i - 3) * 3, 10 + (i - 3) * 2],
            opacity: [0, 1, 0],
            scale: [0, 1.2, 0]
          }} transition={{
            duration: 0.8,
            repeat: Infinity,
            delay: 1.5 + i * 0.12,
            repeatDelay: 4.2,
            ease: 'easeOut'
          }} data-id="element-350" />)}

            {/* ─── Connection flash at meeting point (at the logo) ─── */}
            <motion.div className="absolute rounded-full pointer-events-none z-10" style={{
            top: '26%',
            right: '18%',
            width: 60,
            height: 60,
            marginRight: -30,
            marginTop: -10,
            background: 'radial-gradient(circle, rgba(0,102,255,0.35) 0%, rgba(0,102,255,0.1) 40%, transparent 70%)'
          }} animate={{
            opacity: [0, 0, 0.9, 0.4, 0],
            scale: [0.5, 0.5, 1.5, 2, 0.5]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            times: [0, 0.28, 0.33, 0.45, 0.6]
          }} data-id="element-351" />

            {/* ─── "TAP" label ─── */}
            <motion.div className="absolute bottom-32 md:bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 px-3 sm:px-4 py-1 sm:py-1.5 rounded-full z-20" style={{
            background: 'rgba(0,102,255,0.1)',
            border: '1px solid rgba(0,102,255,0.2)'
          }} animate={{
            opacity: [0, 0, 1, 1, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            times: [0, 0.28, 0.35, 0.6, 0.75]
          }} data-id="element-352">
              <span className="text-xs sm:text-sm" data-id="element-353">⚡</span>
              <span className="text-[10px] sm:text-xs font-bold text-brand-glow tracking-wider uppercase whitespace-nowrap" data-id="element-354">
                Connected — Profile Unlocked
              </span>
            </motion.div>

            {/* Corner decorative dots */}
            <div className="hidden md:block absolute top-4 left-4 w-1 h-1 rounded-full bg-white/10" data-id="element-355" />
            <div className="hidden md:block absolute top-4 right-4 w-1 h-1 rounded-full bg-white/10" data-id="element-356" />
            <div className="hidden md:block absolute bottom-32 md:bottom-4 left-4 w-1 h-1 rounded-full bg-white/10" data-id="element-357" />
            <div className="hidden md:block absolute bottom-32 md:bottom-4 right-4 w-1 h-1 rounded-full bg-white/10" data-id="element-358" />
          </div>
        </motion.div>

        {/* Caption */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-center text-gray-500 text-sm -mt-24 md:mt-8 max-w-md mx-auto px-4" data-id="element-359">
          The QTap tag on the right sleeve connects to any phone instantly —
          unlocking your team profile, live stats, and exclusive content.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center mt-6 pb-8 relative z-50" data-id="element-360">
          <a href="#video-demo" onClick={handleScrollToVideo} className="inline-block bg-[#0066FF] hover:bg-[#0052cc] text-white font-bold text-sm py-3 px-6 rounded-full transition-all hover:-translate-y-1 cursor-pointer" style={{
          touchAction: 'manipulation'
        }} data-id="element-361">
            Watch it in real action
          </a>
        </motion.div>
      </div>
    </section>;
}